/* Chip: unselected = surface-2 fill, selected = tone fill (mobile Chip.tsx). */
.chip {
  --chip-bg: var(--primary);
  --chip-fg: var(--on-primary);

  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.25rem;
  padding: var(--space-2) var(--space-4);
  font-family: var(--font-body);
  font-size: var(--text-md);
  font-weight: var(--weight-semibold);
  max-width: 100%; /* a long label wraps (large text, narrow screens) instead of overflowing */
  text-align: center;
  background: var(--surface-2);
  color: var(--text-2-strong);
  border: var(--border-width) solid transparent;
  border-radius: var(--radius-pill);
  cursor: pointer;
}

.chip[data-bordered] {
  border-color: var(--border);
}

.chip[aria-pressed='true'] {
  background: var(--chip-bg);
  color: var(--chip-fg);
}

.chip[data-tone='secondary'] {
  --chip-bg: var(--secondary);
  --chip-fg: var(--on-secondary);
}

.chip[data-tone='neutral'] {
  --chip-bg: var(--text);
  --chip-fg: var(--bg);
}

.chip[data-tone='success'] {
  --chip-bg: var(--success-strong);
  --chip-fg: var(--on-success-strong);
}

/* Badge: soft fill with strong text (mobile Badge.tsx). */
.badge {
  --badge-bg: var(--success-soft);
  --badge-fg: var(--success-strong);

  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-1) var(--space-2);
  font-family: var(--font-heading);
  font-size: var(--text-sm);
  font-weight: var(--weight-bold);
  background: var(--badge-bg);
  color: var(--badge-fg);
  border-radius: var(--radius-pill);
}

.badge[data-small] {
  padding: 0 var(--space-2);
  font-size: var(--text-xs);
}

.badge[data-variant='primary'] {
  --badge-bg: var(--primary-soft);
  --badge-fg: var(--primary-strong);
}

.badge[data-variant='secondary'] {
  --badge-bg: var(--secondary-soft);
  --badge-fg: var(--secondary-text-strong);
}

.badge[data-variant='neutral'] {
  --badge-bg: var(--surface-2);
  --badge-fg: var(--text-2-strong);
}

.badge[data-variant='danger'] {
  --badge-bg: var(--primary-soft);
  --badge-fg: var(--danger-text);
}
